import { query, models } from '@kurtosys/ksys-app-template';
import {
    IQueryContext,
    IQueryKeyValue,
    IExecutionOptions,
} from '@kurtosys/ksys-api-client/dist/models/commonTypes';
import { IQueryContextConfigurationDocumentEntityKey } from '@kurtosys/ksys-app-template/dist/models/query';

export default function getQueryResults(
    queryContext: IQueryContext,
    queries: IQueryKeyValue,
    culture?: string,
    inputs?: object,
    fundManager?: models.api.dictionary.IFundManager,
    documentEntityKeys?: IQueryContextConfigurationDocumentEntityKey,
    translateFn?: (key: string, placeholders?: any) => string
) {
    if (queryContext && queries) {
        const executionOptions: IExecutionOptions = {
            culture,
            inputs,
            fallbackCulture: 'en-GB',
            context: queryContext,
            fundManagerContext: fundManager,
            contextConfiguration: {
                documentEntityKeys,
            },
        };
        const queriesObj = JSON.parse(JSON.stringify(queries));

        // Translate number thresholds before using them in the query format
        if (translateFn) {
            Object.keys(queriesObj).forEach(queryKey => {
                const { format } = queriesObj[queryKey];
                if (
                    format &&
                    format.options &&
                    format.options.numberThresholds
                ) {
                    format.options.numberThresholds.forEach(numberThreshold => {
                        numberThreshold.text = translateFn(
                            numberThreshold.text
                        );
                    });
                }
            });
        }
        const result = query.Query.convertQueryMime(
            queriesObj,
            executionOptions
        );
        return result;
    }
    return {};
}



// WEBPACK FOOTER //
// ./src/utils/query/getQueryResults.ts